
<script>

import BotChannelFormWhatsApp from '@components/bot-channel-form-whatsapp'

export default {

  components: {
    BotChannelFormWhatsApp
  },

  props: {
    bot_channel_uuid: { type: String },
    channel_uuid: { type: String },
    channel_code: { type: String },
    bot_uuid: { type: String },
  }, 

  data() {
    return {
      uuid: null,
      config: {},
      status: null,
    }
  },

  computed: {
    bots_channels_item(){
      return this.$store.getters['botsChannels/GET_BOTS_CHANNELS_ITEM'];
    },
  },

  async mounted () {

    if(this.channel_code === 'whatsapp'){
      this.config = {
        phone: '',
        session: '',
      }
    }

    if(this.bot_channel_uuid !== null){

      this.uuid = this.bot_channel_uuid;

      await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_ITEM', { uuid: this.bot_channel_uuid });

      this.status = this.bots_channels_item.status;

      if(this.bots_channels_item.config){
        this.config = JSON.parse(this.bots_channels_item.config);
      }      
    }
  },

  methods: {
    async save(fl_close = true) {

      let data_send = {
        'bot_uuid': this.bot_uuid,
        'channel_uuid': this.channel_uuid,
        'config': JSON.stringify(this.config),
        'status': this.status
      };

      let result = '';

      if(this.uuid === null){
        result = await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_CREATE', data_send);
      } else {
        data_send.uuid = this.uuid;
        result = await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_UPDATE', data_send);
      }

      if(result === false){
        alert('Возникла ошибка');
      } else {
        if(fl_close){
          this.close();
        } else {
          this.uuid = result.uuid;
        }
      }
    },

    close() {
      // console.log('close')
      this.$emit('close')
    }
  }
}

</script>

<template>
  <b-form
      class="form-horizontal"
      @submit.prevent="save"
  >
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
              <BotChannelFormWhatsApp v-if="channel_code === 'whatsapp'" />
          </div>
        </div>
      </div>
    </div>
  </b-form>  
</template>

<style scoped>
.btn-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>